import {
  CREATE_NOTIFICATION,
  DISMISS_NOTIFICATION
} from '../constants/notification';

const initialState = {
  notification: null,
  dismissedNotifications: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_NOTIFICATION:
      return {
        ...state,
        dismissedNotifications: state.notification ? [state.notification, ...state.dismissedNotifications] : state.dismissedNotifications,
        notification: action.notification
      };
    case DISMISS_NOTIFICATION:
      return {
        ...state,
        dismissedNotifications: [state.notification, ...state.dismissedNotifications],
        notification: null
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/notification.js